export { default as MainLayout } from './main'



// WEBPACK FOOTER //
// ./src/modules/layout/index.js